import { Shimmer } from "./Loading.styles"

const Loadable = ({ loading, loader = <Shimmer /> , children }) => {
    return loading
        ? loader
        : children
}

export default Loadable